import {
  DateRange,
  defaultDateRangeFilters,
  Option,
  SplitBy,
} from "@intentsify/types";
import { isPopulatedArray } from "@intentsify/utils";
import {
  DateRangeFilter,
  Filter,
  FiltersContainer,
  FiltersContainerItem,
  FiltersContainerItemSize,
  SplitByFilter,
} from "components";
import { useParams } from "react-router-dom";
import { useAtomValue, useSetAtom } from "jotai";
import { useResetAtom } from "jotai/utils";
import {
  topTrendingDomainsDateRangeAtom,
  topTrendingDomainsSplitByAtom,
  topTrendingDomainsStateSelector,
  topTrendingSelectedDomainsAtom,
  trendingDomainsOptionsStateAtom,
} from "../../TopTrendingAccounts.state";

const Filters = () => {
  const campaignId = Number(useParams<"campaignId">().campaignId);
  const {
    selectedDomains,
    isLoading,
    topTrendingDomainsOptions,
    selectedSplitBy,
    selectedDateRange,
  } = useAtomValue(topTrendingDomainsStateSelector);
  const setSelectedDomains = useSetAtom(topTrendingSelectedDomainsAtom);
  const resetOptions = useResetAtom(trendingDomainsOptionsStateAtom);
  const setSplitBy = useSetAtom(topTrendingDomainsSplitByAtom);
  const setDateRange = useSetAtom(topTrendingDomainsDateRangeAtom);

  const onSelectedAccountsChange = (options: Array<Option<number>>) => {
    setSelectedDomains({ campaignId, data: options });
  };

  const hasNoOptions = !isPopulatedArray(topTrendingDomainsOptions);

  const items: FiltersContainerItem[] = [
    {
      component: (
        <Filter
          minW={"400px"}
          label={"Accounts"}
          options={topTrendingDomainsOptions}
          isLoading={isLoading}
          isDisabled={isLoading || hasNoOptions}
          placeholder="Select accounts"
          onFilterValuesChange={(options) => {
            onSelectedAccountsChange(options);
          }}
          selected={selectedDomains.data ?? []}
        />
      ),
      size: FiltersContainerItemSize.XL,
    },
    {
      component: (
        <DateRangeFilter<DateRange>
          isLoading={isLoading}
          isDisabled={isLoading}
          dateRange={selectedDateRange}
          options={defaultDateRangeFilters.dateRangeOptions}
          onChange={(value) => {
            resetOptions();
            setDateRange(value);
          }}
        />
      ),
    },
    {
      component: (
        <SplitByFilter<SplitBy>
          onChange={(value) => setSplitBy(value)}
          options={defaultDateRangeFilters.splitByOptions}
          value={selectedSplitBy}
          isLoading={isLoading}
          isDisabled={isLoading || hasNoOptions}
        />
      ),
    },
  ];

  return <FiltersContainer items={items} />;
};

export { Filters };
